import type {SVGProps} from 'react'

const SvgEye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={24}
    height={24}
    fill={'none'}
    viewBox={'0 0 24 24'}
    {...props}
  >
    <path
      stroke={'currentColor'}
      strokeLinecap={'round'}
      strokeWidth={1.25}
      d={'M22.375 12c0 .428-.224 1.044-.746 1.768-.512.71-1.267 1.462-2.217 2.15-1.903 1.379-4.527 2.457-7.412 2.457s-5.509-1.078-7.412-2.456c-.95-.689-1.705-1.441-2.217-2.15-.522-.725-.746-1.341-.746-1.769s.224-1.044.746-1.768c.512-.71 1.267-1.462 2.217-2.15C6.491 6.702 9.115 5.624 12 5.624s5.509 1.078 7.412 2.456c.95.689 1.705 1.441 2.217 2.15.522.725.746 1.341.746 1.769Z'}
    />
    <circle
      cx={12}
      cy={12}
      r={2.875}
      stroke={'currentColor'}
      strokeLinecap={'round'}
      strokeWidth={1.25}
    />
    <circle
      cx={10.75}
      cy={10.75}
      r={1.5}
      fill={'currentColor'}
    />
  </svg>
)
export default SvgEye
